// Hospital data sourced from official PPT
export const HOSPITAL = {
  name: "Godhra Heart & Super Specialty Hospital",
  shortName: "Godhra Heart Hospital",
  tagline: "Where Every Heartbeat Matters",
  domain: "ghodhraheart.in",
  phone: "+91-XXXXX XXXXX",
  phoneRaw: "+91XXXXXXXXXX",
  email: "info@ghodhraheart.in",
  emergency: "+91-XXXXX XXXXX",
  address: {
    line1: "Panjara Pole, Nr Bhavnagri Shop",
    city: "Godhra",
    district: "Panchmahal",
    state: "Gujarat",
    country: "India",
    pincode: "389001",
  },
  beds: 75,
};

export const VISION = `To become a leading center of excellence in cardiac and super specialty healthcare in Godhra, delivering compassionate, affordable, and high-quality medical services to all sections of society — especially the underprivileged and tribal communities. We envision evolving into a corporate-level hospital that integrates advanced technology, skilled expertise, and government-supported healthcare schemes to ensure accessible and equitable treatment, including free care for those in need. Through comprehensive disease management and timely emergency care services, we strive to reduce the regional disease burden and save lives across the Godhra district.`;

export const MISSION = [
  "To establish Godhra Heart & Superspecialist Hospital as a center of excellence by delivering comprehensive, ethical, and high-quality cardiac and superspecialist healthcare services to the people of Godhra and surrounding regions.",
  "We are committed to introducing and sustaining the region's first full-time interventional cardiology and cardiothoracic surgery services, ensuring timely access to advanced, life-saving treatments within the community.",
  "Our mission is to achieve and maintain national standards of clinical excellence through skilled professionals, advanced technology, and evidence-based practices, while ensuring patient safety, affordability, and compassionate care.",
  "We aim to actively collaborate and empanel with government health schemes and regulatory bodies to maximize accessibility, reduce financial burden, and extend the benefits of our services to the widest possible population.",
  "Through continuous improvement, community engagement, and a patient-centric approach, we strive to improve health outcomes and become a trusted healthcare institution for generations.",
];

export const CORE_VALUES = [
  { title: "Patient First", desc: "We place patients at the center of everything we do, ensuring that every decision and action prioritizes their health, safety, and well-being." },
  { title: "Dignity & Respect", desc: "We treat every patient with compassion, empathy, and respect, upholding their dignity, privacy, and individual rights at all times." },
  { title: "Transparency", desc: "We believe in open and honest communication with patients and their families, ensuring clarity in diagnosis, treatment options, outcomes, and costs." },
  { title: "Accountability", desc: "We take responsibility for our actions and outcomes, maintaining the highest standards of clinical and ethical practice." },
  { title: "Professionalism & Excellence", desc: "We are committed to maintaining the highest levels of medical expertise, ethical conduct, and continuous learning to deliver quality care aligned with national standards." },
  { title: "Teamwork & Collaboration", desc: "We foster a culture of mutual respect and collaboration among healthcare professionals to provide coordinated, efficient, and holistic patient care." },
  { title: "Community Engagement", desc: "We actively engage with and serve the community through awareness, prevention, and outreach programs, striving to improve overall public health." },
];

export const SERVICES = [
  { id: "interventional-cardiology", name: "Interventional Cardiology", icon: "heart-pulse",
    desc: "Angiography, angioplasty (PTCA), stenting, primary PCI for heart attack, structural heart procedures, and pacemaker implantation — supported by a state-of-the-art Cath Lab." },
  { id: "non-interventional-cardiology", name: "Non-Interventional Cardiology", icon: "stethoscope",
    desc: "Comprehensive consultations, ECG, 2D Echo, TMT, holter monitoring, heart-failure management, and preventive cardiology programs for long-term heart health." },
  { id: "cardiothoracic-vascular-surgery", name: "Cardiothoracic & Vascular Surgery", icon: "activity",
    desc: "CABG (bypass surgery), valve replacement and repair, congenital heart surgery, peripheral and aortic vascular procedures performed by experienced surgical teams." },
  { id: "ent", name: "ENT (Ear, Nose & Throat)", icon: "ear",
    desc: "Diagnosis and treatment of ear, nose, throat and sinus disorders — including endoscopic sinus surgery, microsurgery, audiology and pediatric ENT care." },
  { id: "head-neck-oncology", name: "Head & Neck Oncology", icon: "shield-plus",
    desc: "Specialized cancer care for the head and neck region — early detection, multidisciplinary planning, and advanced surgical management of tumors." },
  { id: "oncology-surgery", name: "Oncology Surgery", icon: "ribbon",
    desc: "Surgical treatment of solid-organ cancers with a focus on safe, evidence-based oncologic outcomes and coordinated post-operative care." },
  { id: "general-medicine", name: "General Medicine", icon: "stethoscope",
    desc: "Routine and complex internal medicine — diabetes, hypertension, infectious diseases, respiratory illnesses, and lifestyle-disorder management." },
  { id: "general-surgery", name: "General & Laparoscopic Surgery", icon: "scissors",
    desc: "Minimally invasive laparoscopic procedures for gallbladder, hernia, appendix and other general-surgical conditions, alongside open surgical care." },
  { id: "maxillofacial-surgery", name: "Maxillofacial Surgery", icon: "smile",
    desc: "Surgical management of facial trauma, jaw deformities, oral pathology and reconstructive procedures of the face, mouth and jaws." },
  { id: "critical-care", name: "Critical Care", icon: "heart",
    desc: "Round-the-clock intensive care across ICU, CICU and Post-ICU units — managing life-threatening illnesses with multidisciplinary expertise." },
];

export const FACILITIES = [
  { name: "Outpatient Department (OPD)", count: "" },
  { name: "Male General Ward", count: "10 Beds" },
  { name: "Female General Ward", count: "9 Beds" },
  { name: "Special Rooms", count: "11 Beds" },
  { name: "Emergency Department", count: "4 Beds" },
  { name: "Intensive Care Unit (ICU)", count: "11 Beds" },
  { name: "Post-ICU Unit", count: "3 Beds" },
  { name: "Cardiac Intensive Care Unit (CICU)", count: "3 Beds" },
  { name: "Operation Theatres", count: "Major & Minor OT" },
  { name: "Cardiac Catheterization Laboratory (Cath Lab)", count: "" },
  { name: "Clinical Laboratory Services", count: "" },
  { name: "Pharmacy Services", count: "24x7" },
  { name: "Central Sterile Supply Department", count: "CSSD" },
];

export const DOCTORS = [
  {
    id: "dr-devratsinh-parmar",
    name: "Dr. Devratsinh Parmar",
    title: "Director — Interventional Cardiology",
    qualifications: "MBBS, MD, DM (Cardiology)",
    image: "/assets/dr-parmar.png",
    bio: "A skilled cardiologist and Assistant Professor at UNMICRC, Ahmedabad, specializing in complex and rare heart conditions. With advanced training and expertise in endovascular procedures, Dr. Parmar is committed to delivering evidence-based, high-quality cardiac care. He is also actively involved in training future cardiologists and advancing clinical research in cardiology.",
    specialties: ["Interventional Cardiology", "Endovascular Procedures", "Complex Cardiac Care", "Clinical Research"],
  },
  {
    id: "dr-ditika-mahida",
    name: "Dr. Ditika Mahida",
    title: "Director — ENT & Head-Neck Oncology",
    qualifications: "MBBS, DLO, DNB, FHNO",
    image: "/assets/dr-mahida.png",
    bio: "Dr. Mahida is skilled in performing a wide range of ENT and advanced oncological surgeries and continuously strives to enhance her knowledge while delivering quality healthcare. She has experience managing ENT and head & neck oncology cases across OPD, wards, ICU and emergency settings, ensuring comprehensive patient care.",
    specialties: ["ENT Surgery", "Head & Neck Oncology", "Endoscopic Procedures", "Critical ENT Care"],
  },
];

export const STATS = [
  { value: "75", label: "Hospital Beds" },
  { value: "10+", label: "Super-Specialty Departments" },
  { value: "24/7", label: "Emergency & Critical Care" },
  { value: "1st", label: "Full-Time Cath Lab in Region" },
];

